/* eslint-disable class-methods-use-this */
/* eslint-disable camelcase */
import * as marietta from '../..';

class WebCADConfig {
  // レイヤーサイズ
  get LAYER_SIZE_W(): number { return marietta.webcad.WebCADGlobal.LAYER_SIZE_W; }

  get LAYER_SIZE_H(): number { return marietta.webcad.WebCADGlobal.LAYER_SIZE_H; }

  // 拡大率
  get LAYER_SCALE_MIN(): number { return 0.1; }

  get LAYER_SCALE_MAX(): number { return 5; }

  get PIX_PER_GRID(): number { return 60; }

    MENU_ROOM: marietta.webcad.collection.MenuInfoCollection[] = [];

    MENU_FITTING: marietta.webcad.collection.MenuInfoCollection[] = [];

    MENU_EQUIPMENTequipment: marietta.webcad.collection.MenuInfoCollection[] = [];

    MENU_FURNITURE: marietta.webcad.collection.MenuInfoCollection[] = [];

    MENU_EXTERIOR: marietta.webcad.collection.MenuInfoCollection[] = [];
}
export default WebCADConfig;
